import { memo } from 'react';
import { useLanguage } from '@/contexts/LanguageContext';
import { Star } from 'lucide-react';
import { REVIEWS_KEYS } from '@/constants/translations';

const ReviewsSection = memo(() => {
  const { t } = useLanguage();
  
  const reviews = [
    {
      id: 1,
      name: 'Victor',
      rating: 5,
      comment: t(REVIEWS_KEYS.REVIEW_ONE_COMMENT),
      location: t(REVIEWS_KEYS.REVIEW_ONE_LOCATION)
    },
    {
      id: 2,
      name: 'Christian',
      rating: 5,
      comment: t(REVIEWS_KEYS.REVIEW_TWO_COMMENT),
      location: t(REVIEWS_KEYS.REVIEW_TWO_LOCATION)
    },
    {
      id: 3,
      name: 'Rhonda',
      rating: 5,
      comment: t(REVIEWS_KEYS.REVIEW_THREE_COMMENT),
      location: t(REVIEWS_KEYS.REVIEW_THREE_LOCATION)
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            {t(REVIEWS_KEYS.TITLE)}
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            {t(REVIEWS_KEYS.SUBTITLE)}
          </p>
        </div>
        
        {/* Horizontal scroller on mobile: se ve parte de la siguiente card */}
        <div className="md:hidden mb-4">
          <div
            className="flex gap-6 overflow-x-auto scrollbar-hide snap-x snap-mandatory pb-2 px-2 -mx-2"
            style={{ scrollPaddingLeft: "1rem", scrollSnapType: "x mandatory" }}
          >
            {reviews.map((review, idx) => (
              <div
                key={review.id}
                className="bg-white border border-gray-200 rounded-2xl p-6 shadow-sm hover:shadow-lg transition-shadow duration-200 min-w-[77vw] max-w-[310px] snap-center flex-shrink-0"
                style={{
                  animation: "fade-in 0.5s"
                }}
              >
                <div>
                  <p className="font-semibold text-gray-900">{review.name}</p>
                  <p className="text-sm text-gray-500">{review.location}</p>
                </div>
                <div className="flex items-center my-2">
                  {[...Array(5)].map((_, i) => (
                    <Star key={i} className={`w-4 h-4 ${i < review.rating ? 'fill-yellow-400 text-yellow-400' : 'text-gray-300'}`} />
                  ))}
                </div>
                <p className="text-gray-700 mb-4 leading-relaxed">"{review.comment}"</p>
              </div>
            ))}
          </div>
          {/* Indicadores de scroll (círculos abajo) */}
          <div className="flex justify-center gap-2 mt-4">
            {reviews.map((_, idx) => (
              <div key={idx} className="w-2 h-2 rounded-full bg-gray-300" />
            ))}
          </div>
        </div>

        {/* Grid de comentarios - Desktop y Tableta */}
        <div className="hidden md:grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {reviews.map(review => (
            <div 
              key={review.id} 
              className="bg-white border border-gray-200 rounded-2xl p-6 shadow-sm hover:shadow-lg transition-shadow duration-200"
              style={{ animation: "fade-in 0.5s" }}
            >
              <div>
                <p className="font-semibold text-gray-900">{review.name}</p>
                <p className="text-sm text-gray-500">{review.location}</p>
              </div>
              <div className="flex items-center my-2">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className={`w-4 h-4 ${i < review.rating ? 'fill-yellow-400 text-yellow-400' : 'text-gray-300'}`} />
                ))}
              </div>
              <p className="text-gray-700 mb-4 leading-relaxed">"{review.comment}"</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
});

ReviewsSection.displayName = 'ReviewsSection';

export default ReviewsSection;
